import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { SHOPPING_SORT_OPTIONS } from '../../../constants';
import i18nMessages from './__i18n__';
import {map, find} from 'lodash';
import classNames from 'classnames';

export const ProductListSortSelect = ({
  handleSort,
  intl,
  sort
}) => {
  const messages = i18nMessages();
  const { name: selected_name } = find(SHOPPING_SORT_OPTIONS, { name: sort });

  return (
    <div className={'sort-select'}>
      <div className="title" dangerouslySetInnerHTML={{ __html: intl.formatMessage(messages['Sort By']) }} />
      <ul data-type={selected_name}>
        {
          map(SHOPPING_SORT_OPTIONS, ({ name }) => (
            <li key={name}>
              <a className={classNames({ selected: selected_name === name })}
                onClick={handleSort}
                data-name={name}
                onKeyPress={handleSort}
                tabIndex="0"
              >
                {intl.formatMessage(messages[name])}
              </a>
            </li>
          ))
        }
      </ul>
    </div>
  );
};

ProductListSortSelect.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  handleSort: PropTypes.func.isRequired,
  sort: PropTypes.oneOf([
    'newest',
    'low > high',
    'high > low'
  ]).isRequired
};

export default injectIntl(ProductListSortSelect);
